// extracted by mini-css-extract-plugin
export default {"container":"_6a0ec8ae"};